module.exports = __webpack_public_path__ + "assets/img/zh-Hant-d24fdd80.png";